"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M17.654 11.644c-.331-.103-.558-.173-.385-.624.375-.978.414-1.822.007-2.425-.763-1.13-2.85-1.069-5.242-.03 0 0-.752.34-.56-.277.368-1.227.312-2.253-.26-2.846-1.298-1.346-4.75.05-7.71 3.118C1.286 10.857 0 13.293 0 15.398c0 4.028 4.983 6.722 9.86 6.722 6.39 0 10.643-4.094 10.643-7.15 0-1.846-1.501-2.893-2.85-3.326zm-7.782 8.67c-3.89.393-7.248-1.407-7.501-4.022-.253-2.615 2.697-5.054 6.587-5.448 3.891-.394 7.25 1.407 7.502 4.021.252 2.616-2.696 5.055-6.588 5.45zM24 8.364C23.998 4.297 20.76 1 16.764 1a.852.852 0 00-.844.86c0 .474.377.86.844.86 3.064 0 5.548 2.528 5.548 5.647 0 .475.378.86.844.86a.852.852 0 00.844-.86v-.003zm-3.355-.126c-.385-1.918-1.87-3.43-3.754-3.822a.844.844 0 00-.996.669.86.86 0 00.656 1.014 3.17 3.17 0 012.44 2.485.847.847 0 00.998.669.86.86 0 00.656-1.015zM7.877 13.405c-1.568.321-2.625 1.66-2.363 2.989.263 1.33 1.746 2.147 3.313 1.826 1.567-.32 2.625-1.658 2.363-2.988s-1.746-2.147-3.313-1.827z" }), "Weibo");
//# sourceMappingURL=Weibo.js.map